import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminAccountModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminAccountModule;